import { asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import { useRef } from 'react';
import { Button } from 'remote-com-shared/components/Button';
import HeaderContext from 'remote-com-shared/components/Header/context';
import { NavigationSecondary } from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import { Hero as HeroComponent } from 'remote-com-shared/components/Hero';
import { ImageBackgroundStyle, Title, Description } from 'remote-com-shared/components/Hero/styles';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import styled from 'styled-components';

import HeroBgImage from './assets/hero-bg.png';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { IconDropdown, ScrollButton, ActionsWrapper } from '@/src/views/G2LeaderPage/HeroSlice';
import { Header } from '@/src/views/SharedEvents/Header';

const Hero = styled(HeroComponent)`
  background: #5700ff;
  position: relative;
  overflow: hidden;
  padding-top: 0;

  ${Title} {
    font-family: var(--typography-fontBossa);
  }

  ${Description} {
    color: var(--colors-blank);
  }

  ${ActionsWrapper} {
    padding-top: 100px;
    font-family: var(--typography-fontBrand);
    font-weight: 500;
  }
`;

const HeroIllustration = styled.div`
  ${ImageBackgroundStyle}
  display: flex;
  right: 0;
  bottom: 0;
  max-width: 70%;
`;

const CTAButton = styled(Button)`
  && {
    background: #5700ff;
    color: var(--colors-blank);
    border-color: var(--colors-turquoise);
  }
`;

export function HeroSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { title, description, readMore, ctaLabel } = primary;
  const headerRef = useRef(null);
  const { hubspotFormDefinition, formTitle, formDescription, formButtonLabel } = context;

  return (
    <>
      <HeaderContext.Provider value={headerRef}>
        <Header ref={headerRef} hideBanner useRemoteFont>
          <NavigationSecondary>
            {ctaLabel && (
              <TwoStepFormModalButton
                formTitle={formTitle}
                formDescription={asText(formDescription)}
                hubspotFormDefinition={hubspotFormDefinition}
                buttonLabel={formButtonLabel}
                companyEmailAddressesOnly
                button={{ as: CTAButton }}
                formID="header-two-step-form"
              >
                {ctaLabel}
              </TwoStepFormModalButton>
            )}
          </NavigationSecondary>
        </Header>

        <Hero
          title={<PrismicRichText field={title} />}
          description={<PrismicRichText field={description} />}
          actions={
            <ActionsWrapper>
              <ScrollButton href="#special-offer">
                {readMore || 'Read more'} <IconDropdown />
              </ScrollButton>
            </ActionsWrapper>
          }
          background={
            <HeroIllustration>
              <Image src={HeroBgImage} quality="100" alt="" />
            </HeroIllustration>
          }
          preview="0vh"
        />
      </HeaderContext.Provider>
    </>
  );
}
